
import { useState } from 'react';
import MobileBottomNav from '../../components/feature/MobileBottomNav';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Navbar from '../../components/feature/Navbar';

export default function Support() {
  const [activeTab, setActiveTab] = useState('faq');

  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-50 via-white to-cyan-50">
      <Navbar />

      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-8 pb-24 md:pb-8">
        {/* Header */}
        <div className="mb-4 md:mb-6">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1 md:mb-2">Help &amp; Support</h1>
          <p className="text-sm md:text-base text-gray-600">Find answers or reach out to our team</p>
        </div>

        {/* Quick Contact Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-5">
          <a href="tel:+2348001234567" className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all cursor-pointer flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-navy-100 to-cyan-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-phone-line text-navy-600 text-xl"></i>
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-gray-900">Call Us</p>
              <p className="text-xs text-gray-500 truncate">0800-123-4567</p>
            </div>
          </a>
          <a href="mailto:support@vtuapp.ng" className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all cursor-pointer flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-emerald-100 to-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-mail-line text-emerald-600 text-xl"></i>
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-gray-900">Email Us</p>
              <p className="text-xs text-gray-500 truncate">support@vtuapp.ng</p>
            </div>
          </a>
          <a href="https://wa.me/2348001234567" target="_blank" rel="noopener noreferrer nofollow" className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all cursor-pointer flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-green-100 to-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-whatsapp-line text-green-600 text-xl"></i>
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-gray-900">WhatsApp</p>
              <p className="text-xs text-gray-500 truncate">Chat with us</p>
            </div>
          </a>
        </div>

        {/* Tab Switcher */}
        <div className="bg-white rounded-xl shadow-sm p-1 mb-5 flex">
          <button
            onClick={() => setActiveTab('faq')}
            className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              activeTab === 'faq' ? 'bg-navy-600 text-white' : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <i className="ri-question-line mr-1.5"></i>
            FAQ
          </button>
          <button
            onClick={() => setActiveTab('contact')}
            className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              activeTab === 'contact' ? 'bg-navy-600 text-white' : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <i className="ri-mail-send-line mr-1.5"></i>
            Contact
          </button>
          <button
            onClick={() => setActiveTab('channels')}
            className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              activeTab === 'channels' ? 'bg-navy-600 text-white' : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <i className="ri-customer-service-2-line mr-1.5"></i>
            Live Help
          </button>
        </div>

        {/* FAQ Tab */}
        {activeTab === 'faq' && <FAQSection />}

        {/* Contact Tab */}
        {activeTab === 'contact' && <ContactSection />}

        {/* Live Help Tab */}
        {activeTab === 'channels' && (
          <div className="space-y-4">
            {/* Live Chat */}
            <div className="bg-white rounded-xl shadow-sm p-5 md:p-7">
              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-4">Live Chat Support</h3>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-2.5 h-2.5 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-sm text-gray-600">Support agents are online</span>
              </div>
              <p className="text-sm text-gray-500 mb-5">
                Our support team is available Monday to Saturday, 8:00 AM – 10:00 PM WAT. Average response time is under 3 minutes.
              </p>
              <button className="px-6 py-2.5 bg-navy-600 text-white rounded-lg text-sm font-medium hover:bg-navy-700 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-chat-3-line"></i>
                </div>
                Start Live Chat
              </button>
            </div>

            {/* Social Media */}
            <div className="bg-white rounded-xl shadow-sm p-5 md:p-7">
              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-4">Follow Us</h3>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                {[
                  { name: 'Twitter / X', icon: 'ri-twitter-x-line', color: 'from-gray-800 to-gray-900', url: '#' },
                  { name: 'Instagram', icon: 'ri-instagram-line', color: 'from-pink-500 to-rose-500', url: '#' },
                  { name: 'Facebook', icon: 'ri-facebook-line', color: 'from-sky-600 to-sky-700', url: '#' },
                  { name: 'Telegram', icon: 'ri-telegram-line', color: 'from-cyan-500 to-cyan-600', url: '#' },
                ].map((social, i) => (
                  <a
                    key={i}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="flex flex-col items-center gap-2 p-4 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer"
                  >
                    <div className={`w-10 h-10 bg-gradient-to-br ${social.color} rounded-full flex items-center justify-center`}>
                      <i className={`${social.icon} text-white text-lg`}></i>
                    </div>
                    <span className="text-xs font-medium text-gray-700">{social.name}</span>
                  </a>
                ))}
              </div>
            </div>

            {/* Office Info */}
            <div className="bg-white rounded-xl shadow-sm p-5 md:p-7">
              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-4">Office Address</h3>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-navy-100 to-cyan-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-navy-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-700 font-medium">VTU App Headquarters</p>
                  <p className="text-sm text-gray-500 mt-1">15 Admiralty Way, Lekki Phase 1, Lagos, Nigeria</p>
                  <p className="text-xs text-gray-400 mt-1">Mon – Sat: 8:00 AM – 6:00 PM WAT</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>

      <MobileBottomNav />
    </div>
  );
}
